import { render } from "./QuickClientCreate.vue?vue&type=template&id=e6aceeb0"
import script from "./QuickClientCreate.vue?vue&type=script&lang=js"
export * from "./QuickClientCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__